import * as Sentry from '@sentry/vue'
import { AxiosError } from 'axios'
import { showError } from './ui'

export class HandledError extends Error {
  originalError: any
  constructor(message: string, originalError: any) {
    super(message)
    this.originalError = originalError
  }
}

export function handleError(
  error: any,
  baseMessage = 'Hm, something went wrong.',
  options?: { toast?: boolean },
) {
  const errorMessage = getErrorMessage(error)
  const userMessage = baseMessage + (errorMessage ? `\n${errorMessage}` : '')
  if (error.name !== 'AbortError' && error.name !== 'CanceledError') {
    const status = error instanceof AxiosError ? error.response?.status : undefined
    if (options?.toast !== false && status !== 401) {
      showError(userMessage)
    }
    Sentry.captureException(error)
    console.error(error)
  }
  return new HandledError(userMessage, error)
}

function getErrorMessage(error: any): string | null | undefined {
  if (error instanceof AxiosError) {
    const detail = error.response?.data?.detail
    if (Array.isArray(detail)) {
      const messages = detail.map(getDetailMessage).filter((m): m is string => Boolean(m))
      if (messages.length > 0) {
        return messages.join('\n')
      }
    } else {
      const message = getDetailMessage(detail)
      if (message) {
        return message
      }
    }
  }
  return error.message
}

function getDetailMessage(detail: any): string | null {
  if (typeof detail === 'string') {
    return detail
  }
  if (!detail || typeof detail !== 'object') {
    return null
  }
  const loc = Array.isArray(detail.loc) && detail.loc.length > 0 ? detail.loc.join('.') : null
  if (typeof detail.msg === 'string') {
    return loc ? `${detail.msg} (${loc})` : detail.msg
  }
  if (detail.type === 'unique') {
    const fieldLabel = typeof detail.ctx?.field_label === 'string' ? detail.ctx.field_label : null
    const uniqueCheck =
      Array.isArray(detail.ctx?.unique_check) && detail.ctx.unique_check.length > 0
        ? detail.ctx.unique_check.join(', ')
        : null
    const subject = fieldLabel || uniqueCheck || loc
    return subject ? `${subject} must be unique` : 'Must be unique'
  }
  if (typeof detail.type === 'string' && detail.type.length > 0) {
    const typeMessage = detail.type.replaceAll('_', ' ')
    return loc ? `${typeMessage} (${loc})` : typeMessage
  }
  return null
}
